import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-basic-headcount-report',
  templateUrl: './basic-headcount-report.component.html',
  styleUrls: ['./basic-headcount-report.component.scss']
})
export class BasicHeadcountReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
